import { toast } from 'react-toastify'
import type { ToastOptions } from 'react-toastify'
import { getToastIdForError, getToastIdForSuccess } from './requests'

interface Result {
    message: string
    success: boolean
}

export interface JsonResponseWithResultsData {
    results: Result[]
}

export interface JsonResponseWithResults<T extends JsonResponseWithResultsData> {
    data: T
}

export function toastSuccess(message: string, options?: ToastOptions) {
    toast.success(message, { ...options, toastId: getToastIdForSuccess(message) })
}

export function toastJsonResults<T extends JsonResponseWithResultsData>(response: JsonResponseWithResults<T>) {
    if (response.data.results) {
        response.data.results.forEach(result => {
            if (result.success) {
                toastSuccess(result.message)
            } else {
                toast.error(result.message, {
                    autoClose: false,
                    toastId: getToastIdForError(result.message),
                })
            }
        })
    }
}

export function handleApiSuccess(message: string = 'Success') {
    toastSuccess(message)
}
